var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNenhumdadoGenerico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 572.26 494.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 12.15px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #6543fa;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 4.03px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-7 {\n        stroke: #2d2165;\n      }\n\n      .cls-3, .cls-4, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-7 {\n        stroke-width: 2.92px;\n      }\n\n      .cls-8, .cls-7 {\n        fill: #6543fa;\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        fill: #7041ff;\n      }\n\n      .cls-6 {\n        stroke: #fcfdfd;\n      }\n\n      .cls-11 {\n        fill: #94d8f4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.35,
    y: 176.11,
    width: 31.92,
    height: 39.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 173.96,
    y: 122.56,
    width: 31.93,
    height: 93.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 226.58,
    y: 147.83,
    width: 31.93,
    height: 68.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 279.21,
    y: 100.94,
    width: 31.92,
    height: 115.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M218.56,67.32h-58.77c-2.36,0-4.27,1.9-4.27,4.25v24.42c0,2.36,1.9,4.25,4.27,4.25h23.58l1.56,2.7,4.24,7.34,4.24-7.34,1.55-2.7h23.6c2.35,0,4.26-1.89,4.26-4.25v-24.42c0-2.35-1.91-4.25-4.26-4.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 173.32,
    y1: 84,
    x2: 205.03,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 111.08,
    y1: 215.94,
    x2: 328.33,
    y2: 215.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 364.73,
    y: 8.84,
    width: 125.36,
    height: 148.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M183.96,334.02l30.55-30.72,36.09,1.03,3.45-3.5c18.34-18.59,45.66-25.12,70.42-16.85h0c16.25,5.43,32.03,12.13,47.22,20.06l92.8,48.44c6.14,3.21,7.5,11.4,2.72,16.42h0c-12,12.6-30.7,16.16-46.49,8.85l-59.64-27.59.31,15.33c.8,40.2-13.8,79.18-40.81,108.95l-12.15,14.42s-123.55-92.75-124.46-154.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M297.71,494.1h0c-15.63,2.87-30.5-7.83-32.77-23.55l-11.55-80.26c-1.55-10.8,5.45-20.97,16.09-23.38h0c11.17-2.52,22.28,4.4,24.95,15.54l20.4,85.35c2.88,12.06-4.94,24.07-17.13,26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M270.73,473.96l-25.81-2.07c-14.94-1.2-26.61-13.39-27.15-28.37l-3.27-90.11c-.03-10.91,8.33-20.01,19.2-20.91h0c11.41-.94,21.45,7.47,22.54,18.86l14.49,122.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.52,348.86l-18.71,5.27c-31.14,8.77-59.63,2.21-80.69-29.26l-3.68-5.49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M513,353.5c7.42,1.1,14.34-3.99,15.5-11.4l41.62-265.23c.77-4.88-1.99-9.38-6.16-10.03L124.93,2.09c-4.17-.65-8.17,2.78-8.94,7.66l-41.58,264.99c-1.18,7.5,3.99,14.53,11.5,15.64l427.08,63.11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.92,25.07c-.42,2.67-2.92,4.49-5.59,4.07-2.67-.42-4.49-2.92-4.07-5.59.42-2.67,2.92-4.49,5.59-4.07,2.67.42,4.49,2.92,4.07,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.1,27.29c-.42,2.67-2.92,4.49-5.59,4.07-2.67-.42-4.49-2.92-4.07-5.59.42-2.67,2.92-4.49,5.58-4.07,2.67.42,4.49,2.92,4.07,5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M169.28,29.52c-.42,2.67-2.92,4.49-5.58,4.07-2.67-.42-4.49-2.92-4.07-5.59.42-2.66,2.92-4.49,5.59-4.07,2.67.42,4.49,2.92,4.07,5.59Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "475.61 301.96 462.42 311.59 472.03 324.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "497.94 305.47 507.55 318.67 494.35 328.29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 516.04,
    y1: 74.11,
    x2: 514.3,
    y2: 85.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 520.7,
    y1: 80.51,
    x2: 509.63,
    y2: 78.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "531.93 76.24 531.23 80.74 535.73 81.44 536.43 76.95 531.93 76.24 531.93 76.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "530.79 83.52 530.09 88.02 534.58 88.73 535.29 84.23 530.79 83.52 530.79 83.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "539.28 77.39 538.58 81.89 543.07 82.6 543.78 78.1 539.28 77.39 539.28 77.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "538.14 84.68 537.43 89.17 541.93 89.88 542.64 85.38 538.14 84.68 538.14 84.68"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 364.28,
    y1: 239.86,
    x2: 484.76,
    y2: 239.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 364.28,
    y1: 253.63,
    x2: 505.42,
    y2: 253.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 364.28,
    y1: 267.4,
    x2: 444.84,
    y2: 267.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 364.28,
    y1: 186.36,
    x2: 452.98,
    y2: 186.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 364.28,
    y1: 208.75,
    x2: 487.26,
    y2: 208.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M225.86,426.48l-19.23-1.92c-13.03-1.3-23.08-12.08-23.47-25.17l-2.79-93.46c-.03-10.91,6.71-20,15.5-20.89h0c9.22-.93,17.34,7.48,18.22,18.87l11.78,122.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M197.74,401.96l-10.68-1.41c-15.23-2.02-26.59-15.02-26.56-30.38l.16-76.86c.28-9.71,6.55-17.62,14.39-18.16h0c8.23-.57,15.22,7.15,15.69,17.32l7,109.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.66,474.01c-.31-1.13-.55-2.28-.72-3.47l-11.55-80.26c-1.55-10.8,5.45-20.97,16.09-23.38h0c11.17-2.52,22.28,4.4,26.37,16.96l20.4,85.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.1,425.05l-2.6-71.64c-.03-10.91,8.33-20.01,19.2-20.91h0c14.81-1.22,21.84,11.54,22.54,18.86l2.57,21.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.16,399.38l-2.79-93.46c-.03-10.91,6.71-20,15.5-20.89h0c12.68-1.28,17.66,11.62,18.22,18.87l3.73,38.78"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 74.25,
    cy: 134.51,
    r: 74.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.88,110.03l-17.79,14.89-14.89-17.79c-2.41-2.88-6.7-3.26-9.58-.85-2.88,2.41-3.26,6.7-.85,9.58l14.89,17.79-17.79,14.89c-2.88,2.41-3.25,6.7-.84,9.58,2.41,2.87,6.69,3.25,9.57.85l17.79-14.89,14.89,17.79c2.41,2.88,6.7,3.25,9.58.84,2.87-2.41,3.25-6.69.85-9.57l-14.89-17.79,17.79-14.89c2.88-2.41,3.26-6.7.85-9.58-2.41-2.88-6.7-3.26-9.58-.85h0Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNenhumdadoGenerico);
export default __webpack_public_path__ + "static/media/Nenhum dado - Generico.c9eb4551904120150244f4634afac5f7.svg";
export { ForwardRef as ReactComponent };